export default __webpack_public_path__ + "static/media/National-Association-of-State-Boards-of-Accountancy-_NASBA_-Resume-Writing.f5d41434.webp";